import { render, staticRenderFns } from "./KUJUSetting.vue?vue&type=template&id=72be99de&scoped=true"
import script from "./KUJUSetting.vue?vue&type=script&lang=js"
export * from "./KUJUSetting.vue?vue&type=script&lang=js"
import style0 from "./KUJUSetting.vue?vue&type=style&index=0&id=72be99de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be99de",
  null
  
)

export default component.exports